import React, { useCallback, useEffect, useState } from 'react';
import { Card, CardHeader, CardFooter, Row, Col } from 'reactstrap';
import Select from 'react-select';
import PSO from '../../../services/PSO';
import { useAuth } from '../../../Context/Auth/AuthContext';
import { toast } from 'react-toastify';
import Strings from '../../../translations/Translations';
import { useLocation } from 'react-router-dom';
import ShareComponent from '../../../Layout/Components/ShareComponent';
import RemixEmbedComponent from '../../../Layout/Components/RemixEmbedComponent';

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export default function ShareVideoModule(props) {
  const [selectedOption, setSelectedOption] = useState(null);
  const { authenticated, toggleLoading, currentCampaign } = useAuth();
  const [options, setOptions] = useState([]);
  const [its, setIts] = useState();
  const [currentIt, setCurrentIt] = useState(null);

  const query = useQuery();

  const changeIt = useCallback((evt) => {
    setSelectedOption(evt);
    if (its && its.length > 0) {
      const selectedIts = its.filter((value) => {
        if (value.rid === evt.value) {
          return value;
        }
        return false;
      });
      if (selectedIts && selectedIts.length > 0) {
        setCurrentIt(selectedIts[0]);
      }
    }
  }, [setSelectedOption, its, setCurrentIt]);

  const loadLists = useCallback((its, parameterRemixID = null) => {
    let initialOption = null;
    let initialRemix = null;

    setIts(its);
    const optionsToSet = its.map((value) => {
      const option = {
        value: value.rid,
        label: value.rti
      }
      if (parameterRemixID && parameterRemixID === value.rid) {
        initialRemix = value;
        initialOption = option;
      }
      return option;
    });
    setOptions(optionsToSet);

    if (initialOption) {
      setSelectedOption(initialOption);
    }
    if (initialRemix) {
      setCurrentIt(initialRemix);
    }
  }, [setIts, setOptions, setSelectedOption, setCurrentIt]);

  const getVideos = useCallback(async () => {
    const urlParameterRid = query.get('rid');
    toggleLoading(true);

    try {
      const response = await PSO.getRemixListByCollection({
        un: authenticated.un,
        al: authenticated.al,
        colid: currentCampaign.colid
      });

      if (response.result === 'success') {
        loadLists(response.its, urlParameterRid);
      } else {
        const message = (response && response.error) ? response.error : Strings('error_on_request');
        toast.error(message);
      }

      toggleLoading(false);
    } catch (err) {
      toast.error(Strings('general_error'));
      toggleLoading(false);
    }
  }, [authenticated, toggleLoading, loadLists, currentCampaign, query]);

  useEffect(() => {
    getVideos();
  }, [getVideos]);

  return (
    <Card className="mb-3">
      <CardHeader className="card-header-tab z-index-6">
        <div className="card-header-title font-size-lg text-transform-none font-weight-normal">
          Video(s):
          <span className="d-inline-block ml-2" style={{ width: 250 }}>
            <Select
              value={selectedOption}
              onChange={changeIt}
              options={options}
            />
          </span>
        </div>        
      </CardHeader>
      <Row className="no-gutters">
        {currentIt && currentIt.rid && (
          <Col md={12} className="p-3">
            <RemixEmbedComponent currentIt={currentIt} />
          </Col>
        )}
      </Row>
      {currentIt && (
        <CardFooter className="d-block p-3">
          <p>{Strings('share_options')}</p>

          <ShareComponent currentIt={currentIt} />

        </CardFooter>
      )}
    </Card>
  );
}
